export default __webpack_public_path__ + "static/media/Level29.12564908.svg";